import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllSampleRequestThunk = createAsyncThunk(
    'samplerequest/getAllSampleRequest',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllSamplerequest(config);
            //   console.log("dsdc",response.data?.data);

            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportSampleRequest = createAsyncThunk(
    'samplerequest/exportSampleRequest',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllSamplerequest(config);
            //   console.log(response.data?.data);

            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const getSampleRequestDetailsThunk = createAsyncThunk(
    'samplerequest/getSampleRequestDetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getSamplerequestDetails(id);
            //   console.log(response.data?.data);

            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deleteSampleRequestThunk = createAsyncThunk(
    'samplerequest/deleteSampleRequest',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteSampleRequest(id);
            dispatch(setSampleRequestrefresh())
            toast.success('sample request deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error('unable to delete sample request')
        }
    }
);

const sampleRequestSlice = createSlice({
    name: 'samplerequest',
    initialState: {
        samplerequest: [],
        sampleRequestDetails: {},
        refresh: false,
        loading: false,
    exportLoading:false,
        error: null,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
    },
    reducers: {

        setSampleRequestrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setsampleRequestPage: (state, action) => {
            state.page = action.payload
        },
        setSampleSearch: (state, action) => {
            state.search = action.payload
        },
        setSampleStatus: (state, action) => {
            state.status = action.payload
        },
        setSampleFromDate: (state, action) => {
            state.fromDate = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllSampleRequestThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllSampleRequestThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.samplerequest = action.payload;
            })
            .addCase(getAllSampleRequestThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(getSampleRequestDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSampleRequestDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.sampleRequestDetails = action.payload;
            })
            .addCase(getSampleRequestDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportSampleRequest.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportSampleRequest.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportSampleRequest.rejected, (state, action) => {
                state.exportLoading = false;
            })

    },
});

export const { setSampleRequestrefresh, setsampleRequestPage, setSampleSearch, setSampleStatus, setSampleFromDate } = sampleRequestSlice.actions
export default sampleRequestSlice.reducer;

